import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ProviderDataService } from '../../data-services/provider.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { FormsModule } from '@angular/forms';

@Component({
   selector: 'provider-add',
   templateUrl: './provider.add.html',
   styleUrls: ['./provider.add.css'],
   imports: [FormsModule]
})
export class ProviderAddComponent implements OnInit {
   @Output() operationComplete = new EventEmitter<string>();

   constructor(private providerDataService: ProviderDataService,
      public ref: DynamicDialogRef,
      public config: DynamicDialogConfig) {
   }

   searchNPI: string = '';
   searchFirst: string = '';
   searchLast: string = '';
   searchResults: any[];
   searchType: string = 'npi';
   loading: boolean;
   selected: any;

   ngOnInit() {
      this.loading = true;

      this.loading = false;
   }

   public doSearch() {
      if (!this.canSearch()) {
         return;
      }

      this.searchResults = [];

      if (this.searchType == 'npi') {
         this.providerDataService.getByNPI(this.searchNPI).subscribe((data: any) => {
            this.searchResults.push(data);
            console.log(JSON.stringify(this.searchResults));
         });
      }
      else {
         this.providerDataService.searchProviders(this.searchFirst, this.searchLast).subscribe((data: any) => {
            this.searchResults = data;
            console.log(JSON.stringify(this.searchResults));
         });
      }
   }

   selectResult(ind) {
      this.selected = this.searchResults[ind];
      this.ref.close(this.selected);
   }

   canSearch() {
      if (this.searchType == 'npi' && this.searchNPI.length > 0) {
         return true;
      } else if (this.searchType == 'name' && this.searchFirst.length > 0 && this.searchLast.length > 0) {
         return true;
      }

      return false;
   }
}
